export default {
  white: "#fff",
  gray: "#616161",
  primary: "#fac8c2",
  secondary: "#6bbedc",
}
